import React,{PureComponent,Fragment} from 'react';
import {Tabs,Badge,  Tooltip,} from 'antd';
import PageCommon from  "@components/PageCommon/PageCommon";
import { Link } from "react-router-dom"
import {postDeliveryList, postDeliveryListInfo, postBatchDelivery,downloadDeliverOrder} from '@/api/warehouseManagement/outWarehouse';
import {postWaitIntoWarehouseList, postInserIntoWarehouse} from '@/api/warehouseManagement/registration'
import VipLvLevel from "@components/Icon/vip-badge/vipLvLevel";
import { toFixedWithCommas} from "@utils/number-util";
import IconVerified from "@components/Icon/IconVerified";
import {isEmpty,trim, toFixed2,formatNumberToPrice,symbolMoneyUtil,getWeek,getIntlYYMMDD} from '@utils/utils';
import CustomerEmailStatus from "@components/customerEmailStatus/customerEmailStatus";
import eventProxy from '@/utils/eventProxy';
import Lang from "@/components/Lang/Lang";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import CustomerList from './components/InternalList';
import NewBuyerLabelAndHistoryDrawer from "@components/StatuLabel/NewBuyerLabelAndHistoryDrawer"
import AllocationFollowUserBtn from "./components/AllocationFollowUserBtn"
import Cookie from "../../../utils/cookie";
import './CustomerIndex.less' ;
import FollowAction from "../Follow/Follow.action";

class CustomerIndex extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            loading:false,
            waitIntoNum: "",
            tabKay: '-10',
            // 表单 配置
            searchFormOptions:[
                {
                    name:'foreignUserId',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请选择跟进人',
                    cnPlaceholderId:'QingXuanZeGenJinRen',
                    width:180,
                    type:"SearchSelect",
                    searchClass:{
                        api:"/service/mg/follower/search/foreign",
                    },
                },
                {
                    name:'keyword',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'搜索 邮箱/编号/联系电话',
                    cnPlaceholderId:'SouSuoYouXiangBianHaoLian',
                    width:355,
                },
            ],
            tabOptions:[
                {
                    key:'-10',
                    name:Lang({id:"QuanBu", default:"全部"}),
                    count:'allTabNum',
                },
                {
                    key:'10',
                    name:Lang({id:"DaiChuBuLianXi", default:"待初步联系"}),
                    count:'wailTabNum',
                },
                {
                    key:'20',
                    name:Lang({id:"GenJinZhong", default:"跟进中"}),
                    count:'followTabNum',
                },
                {
                    key:'30',
                    name:Lang({id:"ChengGongZhuCe", default:"成功注册"}),
                    count:'registerTabNum',
                },
                {
                    key:'40',
                    name:Lang({id:"GenJinShiBai", default:"跟进失败"}),
                    count:'followFailTabNum',
                },
            ]
        }
    }

    tabsOnChange(key) {
        this.setState({
            tabKay: key,
        },() => {
            this.onPageListChild.reRefreshSearch();
        })
    }
    // 查询回调
    fetchCallBack(res){
        // const {success,valid,model,paging} = res;

    }
    onRefListOne = (ref) =>  this.onPageListChild = ref;
    componentDidMount() {
        eventProxy.on('redirectPage', (path) => { //不知道为啥，旧代码有此逻辑，先加上
            this.props.history.replace(path)
        })
        const optionExtra  = Cookie.getJSON("fmg.extra") || {};
        this.setState(
            {
                optionExtra: optionExtra,
                fxUserId: optionExtra.fxUserId
            },
            () => {
            }
        );
    }
    searchReset(){
        this.setState({
            abnormalTakeTimeSort:''
        },()=>this.onRefAutoFetchListChrld.handleFetch(1,false))
    }
    /**
     * 客户列表统计
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8298
     */
    getStatistics() {
        FollowAction.postAction("/service/mg/follower/count-potential-tab",{

        }).then(res=>this.geStatisticsRes(res.data)).catch(err=>this.geStatisticsRes(err));
    }
    geStatisticsRes(res={}){
        const {success,valid,model,} = res;
        if (success && valid) {
            this.setState({
                tabsNums:model||{}
            })
        }
    }
    getColumns(tabKay){
        return [
            {
                // cnTitle: '客户信息',
                // cnTitleId: 'KeHuLieBiao',
                title: Lang({id: "KeHuLieBiao", default: "客户信息"}),
                dataIndex: 'code',
                width: 180,
                render:(text, item, index) => (<div className={"hoverBox hoverBoxH"}>
                    <div className={"flex-item-ver-center color-blue3 fw_700 font_16"}>
                        {item.code||'-'}
                    </div>
                    {item.email?<div>{item.email}</div>:null}
                    {item.phone?<div className="black45">{item.phone}</div>:null}
                </div>),
            },
            {
                // cnTitle: '注册渠道',
                // cnTitleId: 'ZhuCeQuDao',
                title: Lang({id: "LaiYuanQuDao", default: "来源渠道"}),
                dataIndex: 'buyerFromName',
                render:(code, row, index) => (<>
                    <div className={"mb_4"}>{row.createTime?getIntlYYMMDD(row.createTime):"-"}</div>
                    <div className="fw_500 color-black">{row.buyerFromName||"-"}</div>
                </>)
            },
            {
                // cnTitle: '注册渠道',
                // cnTitleId: 'ZhuCeQuDao',
                title: Lang({id: "ChengJiaoYiXiangDengJi", default: "成交意向等级"}),
                dataIndex: 'buyCustomerIntentLevelName',
                width: 200,
                render:(code, row, index) => (<>
                    <div className="fw_500 intent-level">{row.buyCustomerIntentLevelName||"-"}</div>
                </>)
            },
            {
                title: Lang({id: "ZuiHouGenJinShiJian", default: "最后跟进时间"}),
                dataIndex: 'lastFollowTime',
                width: 230,
                render:(text, row, index) => <>
                    <span>{(row.lastFollowTime && getIntlYYMMDD(row.lastFollowTime, "HH:mm"))||"-"}</span>
                </>
            },
            {
                // cnTitle: '阶段',
                // cnTitleId: 'JieDuan',
                title: Lang({id: "JieDuan", default: "阶段"}),
                dataIndex: 'followStatus',
                width: 300,
                render:(followStatus, row, index) => {
                    const iMillis =  row.remainderFollowTime || 0;
                    const iHour =  Math.ceil(iMillis/1000/60/60);
                    const iDay = Math.ceil(iHour/24);
                    return (<>
                        <div>
                            <NewBuyerLabelAndHistoryDrawer statusCode={followStatus}
                                                           status={row.followStatusName}
                                                           key={row.id+"_"+index}
                                                           reRefreshSearch={()=>{
                                                               this.getStatistics();
                                                               this.onPageListChild.reRefreshSearch(false)}
                                                           }
                                                           labelType={"1030"}//1010:新客标签 1020:成交客户标签 1030：潜在客户
                            />
                        </div>
                        <div className={`mt_4 allocationFollowUserBtnBlue ${row.followUserName?'':' color-blue3'}"}`}>
                            <i className={"ri-user-line mr_4 font_18 black45"} />
                            {row.followUserName||Lang({id:"WeiFenPei",default:"未分配"})}
                        </div>
                    </>)
                }
            },
        ]
    }
    componentWillMount() {
        this.getStatistics()
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const {loading, searchFormOptions, tabsNums={}, tabKay, fxUserId, tabOptions=[]} = this.state;
        return (<PageCommon onRef={this.onRefPageCommon}
                        loading={loading}>
                <CommonBreadcrumb list={[
                    {name:Lang({id:"QianZaiKeHu", default:"潜在客户"})},
                ]}></CommonBreadcrumb>
                <div className={"customerList"}>
                    <Tabs activeKey={tabKay}onChange={this.tabsOnChange.bind(this)}
                        items={
                            tabOptions.map(opt=>{return {
                                key: opt.key,
                                label:( <div className={"flex-item"}>
                                    {opt.name}
                                    {opt.count?<Badge count={tabsNums[opt.count]||0}/>:null}
                                </div>),
                            }} ) }
                    >
                    </Tabs>
                    <CustomerList onRef={this.onRefListOne}
                                  labelType={"1030"}
                                   searchFormOptions={searchFormOptions}
                                   precondition={{
                                       followStatus: tabKay,
                                   }}
                                  getStatistics={this.getStatistics.bind(this)}
                                  fetchCallBack={(data)=>this.fetchCallBack(data)}
                                  fxUserId={fxUserId}
                                  tabKay={tabKay}
                                  allTabs={tabKay=="-10"}
                                  columns={this.getColumns(tabKay)} />
                </div>
            </PageCommon>
        )
    }
}

export default CustomerIndex
